import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateMainFilterModal } from '../../features/mainFilter/mainFilterModalsSlice';

export default function useHandleMainFilterState({ filter, onOpen, onClose }) {
  const isOpen = useSelector(state => state.modals.mainFilter[filter]);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    setOpen(isOpen)
  }, [isOpen]);

  const setIsOpen = useCallback((showModal, isReturn) => {
    let timeout;
    if (open === showModal && !isReturn) return undefined;
    if (showModal && onOpen) onOpen()
    if (!showModal && onClose) onClose()
    setOpen(showModal);
    timeout = setTimeout(() => dispatch(updateMainFilterModal({ [filter]: showModal })), 0)
    if (window.innerWidth < 768 && showModal) {
      window.history.pushState(
        { type: 'something' },
        null,
        window.location.href
      );
    }

    return () => {
      clearTimeout(timeout)
    }
  }, [open, onOpen, onClose, dispatch, filter]);

  useEffect(() => {
    const popupEvent = () => {
      if (open) {
        setIsOpen(false, true);
      }
    };

    if (window.innerWidth < 768 && open) {
      setTimeout(() => window.addEventListener('popstate', popupEvent), 500);
    }

    return () => window.removeEventListener('popstate', popupEvent);
  }, [open, setIsOpen]);

  return [open, setIsOpen]
}
